import { memo, useEffect, useState } from 'react';
import {
    Container,
    Element,
    IconButton,
    Level,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import cn from 'classnames';
import MenuList from '@zmedia/bm-soccer-ui/components/base/components/menu/list';
import { useRouter } from 'next/router';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './styles.module.scss';

const tabs = [
    {
        id: 'news',
        title: 'Tin tức',
        url: URL_SOCCER_PAGE.HOME,
        rawUrl: '/soccer',
    },
    {
        id: 'stadium',
        title: 'Trận đấu',
        url: URL_SOCCER_PAGE.LIVESCORE,
        subUrl: URL_SOCCER_PAGE.LIVE,
        rawUrl: '/soccer/livescore',
    },
    {
        id: 'cup',
        title: 'Giải đấu',
        url: URL_SOCCER_PAGE.ALL_LEAGUES,
        rawUrl: '/soccer/leagues',
    },
];

const tags = [
    { text: 'World Cup 2026', link: '/bong-da/world-cup-giai-dau-406.epi' },
    {
        text: 'Lịch thi đấu World Cup 2026',
        link: '/bong-da/lich-thi-dau-world-cup-giai-dau-406.epi',
    },
    {
        text: 'BXH WC 2026',
        link: '/bong-da/bang-xep-hang-world-cup-giai-dau-406.epi',
    },
    { text: 'Đội tuyển Anh', link: '/tuyen-anh-tag11590.epi' },
    { text: 'Tuyển Pháp', link: '/tuyen-phap-tag4837.epi' },
    { text: 'Đội tuyển Đức', link: '/tuyen-duc-tag4754.epi' },
    { text: 'Đội tuyển Argentina', link: '/tuyen-argentina-tag286.epi' },
    { text: 'Tuyển Hàn Quốc', link: '/tuyen-han-quoc-tag4164.epi' },
    { text: 'Tuyển Tây Ban Nha', link: '/tuyen-tay-ban-nha-tag3613.epi' },
    { text: 'Đội tuyển Bồ Đào Nha', link: '/tuyen-bo-dao-nha-tag947.epi' },
    { text: 'Đội tuyển Nhật Bản', link: '/tuyen-nhat-ban-tag3848.epi' },
    { text: 'Tuyển Hà Lan', link: '/tuyen-ha-lan-tag3902.epi' },
    { text: 'Đội tuyển Brazil', link: '/tuyen-brasil-tag105.epi' },
    { text: 'Messi', link: '/lionel-messi-tag2457.epi' },
    { text: 'Cristiano Ronaldo', link: '/cristiano-ronaldo-tag682.epi' },
    { text: 'U23 Việt Nam', link: '/u23-viet-nam-tag12943.epi' },
    { text: 'U17 Việt Nam', link: '/u17-viet-nam-tag12946.epi' },
    { text: 'đội tuyển Việt Nam', link: '/tuyen-viet-nam-tag113.epi' },
    { text: 'bóng đá việt nam', link: '/bong-da-viet-nam.epi' },
    { text: 'tin thể thao', link: '/the-thao.epi' },
    { text: 'báo bóng đá', link: '/bong-da-quoc-te.epi' },
    { text: 'kết quả bóng đá', link: '/bong-da/livescore.epi' },
    { text: 'bóng đá', link: '/bong-da.epi' },
    { text: 'Ngoại hạng anh', link: '/bong-da/ngoai-hang-anh-giai-dau-1.epi' },
    {
        text: 'bảng xếp hạng ngoại hạng anh',
        link: '/bong-da/bang-xep-hang-ngoai-hang-anh-giai-dau-1.epi',
    },
    {
        text: 'Lịch thi đấu ngoại hạng Anh',
        link: '/bong-da/lich-thi-dau-ngoai-hang-anh-giai-dau-1.epi',
    },
    {
        text: 'champions league',
        link: '/bong-da/champions-league-giai-dau-6.epi',
    },
    {
        text: 'lịch thi đấu c1',
        link: '/bong-da/lich-thi-dau-champions-league-giai-dau-6.epi',
    },
    { text: 'europa league', link: '/bong-da/europa-league-giai-dau-7.epi' },
    {
        text: 'lịch thi đấu c2',
        link: '/bong-da/lich-thi-dau-europa-league-giai-dau-7.epi',
    },
    { text: 'vleague', link: '/bong-da/v-league-giai-dau-13.epi' },
    {
        text: 'bảng xếp hạng vleague',
        link: '/bong-da/bang-xep-hang-v-league-giai-dau-13.epi',
    },
    {
        text: 'lịch thi đấu vleague',
        link: '/bong-da/lich-thi-dau-v-league-giai-dau-13.epi',
    },
    { text: 'la liga', link: '/bong-da/laliga-giai-dau-2.epi' },
    {
        text: 'bảng xếp hạng la liga',
        link: '/bong-da/bang-xep-hang-laliga-giai-dau-2.epi',
    },
    {
        text: 'lịch thi đấu la liga',
        link: '/bong-da/lich-thi-dau-laliga-giai-dau-2.epi',
    },
    { text: 'serie a', link: '/bong-da/serie-a-giai-dau-3.epi' },
    {
        text: 'Thứ hạng của serie a',
        link: '/bong-da/bang-xep-hang-serie-a-giai-dau-3.epi',
    },
    {
        text: 'lịch thi đấu serie a',
        link: '/bong-da/lich-thi-dau-serie-a-giai-dau-3.epi',
    },
    { text: 'ligue 1', link: '/bong-da/ligue-1-giai-dau-4.epi' },
    { text: 'Bundesliga', link: '/bong-da/bundesliga-giai-dau-5.epi' },
    { text: 'FA cup', link: '/bong-da/fa-cup-giai-dau-15.epi' },
    { text: 'MLS', link: '/bong-da/mls-giai-dau-27.epi' },
    {
        text: 'Saudi Pro League',
        link: '/bong-da/saudi-pro-league-giai-dau-28.epi',
    },
    { text: 'Man utd', link: '/manchester-united-tag54.epi' },
    { text: 'man city', link: '/manchester-city-tag3854.epi' },
    { text: 'arsenal', link: '/arsenal-tag100.epi' },
    { text: 'liverpool', link: '/liverpool-tag119.epi' },
    { text: 'Barcelona', link: '/barcelona-tag11263.epi' },
    { text: 'Real madrid', link: '/real-madrid-tag72.epi' },
    { text: 'bayern munich', link: '/bayern-munich-tag12181.epi' },
    { text: 'juventus', link: '/juventus-tag2801.epi' },
    { text: 'al nassr', link: '/inter-miami-tag2946.epi' },
    { text: 'Inter Miami', link: '/al-nassr-tag12819.epi' },
    { text: 'chelsea', link: '/chelsea-tag90.epi' },
    { text: 'neymar', link: '/neymar-tag3914.epi' },
    { text: 'haaland', link: '/erling-haaland-tag70.epi' },
    { text: 'mbappe', link: '/kylian-mbappe-tag1661.epi' },
    { text: 'Đình Bắc', link: '/nguyen-dinh-bac-tag5580.epi' },
    { text: 'nguyễn xuân son', link: '/nguyen-xuan-son-tag14781.epi' },
    { text: 'lamine yamal', link: '/lamine-yamal-tag14510.epi' },
    { text: 'tin tức', link: '/' },
    { text: 'giá vàng', link: '/tien-ich-gia-vang.epi' },
    { text: 'xổ số', link: '/tien-ich-ket-qua-xo-so.epi' },
    { text: 'xsmn', link: '/tien-ich-ket-qua-xo-so-xsmn-mien-nam.epi' },
    { text: 'xsmb', link: '/tien-ich-ket-qua-xo-so-xsmb-mien-bac.epi' },
    {
        text: 'xổ số miền trung',
        link: '/tien-ich-ket-qua-xo-so-xsmt-mien-trung.epi',
    },
    { text: 'vietlott', link: '/tien-ich-ket-qua-vietlott.epi' },
    { text: 'lịch âm', link: '/tien-ich-lich-van-nien.epi' },
    { text: 'bảng giá chứng khoán', link: '/tien-ich-gia-chung-khoan.epi' },
    { text: 'Giá xăng dầu', link: '/tien-ich-gia-xang-dau.epi' },
    { text: 'tin tennis', link: '/quan-vot.epi' },
];

function Footer() {
    const [activeTabId, setActiveTabId] = useState<string>('');
    const router = useRouter();

    useEffect(() => {
        if (!router?.asPath) return;
        const activeTab = tabs.find(
            (tab) =>
                router.asPath.split('?')[0] === tab.url ||
                router.asPath.split('?')[0] === tab.subUrl ||
                router.asPath.split('?')[0] === tab.rawUrl,
        );
        if (activeTab) {
            setActiveTabId(activeTab.id);
        } else {
            setActiveTabId('');
        }
    }, [router.asPath]);

    return (
        <>
            <Element
                renderAs="footer"
                id="BaoMoi_Footer"
                className={cn('bm-footer', 'leading-[1.3]')}
            >
                <Element className={'h-[50px] bg-[var(--primary)]'}>
                    <Container className="h-full">
                        <Level className="h-full">
                            <Level.Side align="left">
                                <RouterLink
                                    to={'/'}
                                    alt="Trang chủ"
                                    title="Trang chủ"
                                    className={cn(
                                        'inline-block w-[120px] h-[36px]',
                                        "bg-[url('https://baomoi-static.bmcdn.me/web/styles/img/desktop-logo-v2.png')]",
                                        'bg-[length:120px_72px]',
                                        'bg-[position:0px_0px]',
                                    )}
                                />
                            </Level.Side>
                        </Level>
                    </Container>
                </Element>
                <Container>
                    <Element
                        className={cn(
                            'text-center',
                            'mt-[15px] mx-0 pb-[10px]',
                            'border-b-[#eee] border-b border-solid',
                            'max-md:pb-[8rem]',
                        )}
                    >
                        {tags.map((item: any, index: number) => {
                            return (
                                <span
                                    className={cn(
                                        'inline-block text-[1.3rem] text-[#6c757d] capitalize',
                                        "before:content-['•']  before:inline-block",
                                        'before:text-[0.8rem] before:leading-[18px] before:text-[#ccc]',
                                        'before:px-[6px] before:py-0',
                                    )}
                                    key={index}
                                >
                                    <RouterLink
                                        to={item.link}
                                        title={item.text}
                                    >
                                        {item.text}{' '}
                                    </RouterLink>
                                </span>
                            );
                        })}
                    </Element>
                </Container>
            </Element>
            <Element className={styles['mobile-footer-wrapper']}>
                <MenuList>
                    {tabs.map((tab) => (
                        <MenuList.Item
                            key={tab.id}
                            className={cn(styles['link'], {
                                [styles['is-active']]: activeTabId === tab.id,
                            })}
                        >
                            <RouterLink to={tab.url} title={tab.title}>
                                <IconButton
                                    icon={tab.id}
                                    text={tab.title}
                                    title={tab.title}
                                ></IconButton>
                            </RouterLink>
                        </MenuList.Item>
                    ))}
                </MenuList>
            </Element>
        </>
    );
}

export default memo(Footer);
